import { combineReducers } from '@reduxjs/toolkit'

import {
  DETACH_PAYMENT_METHODS_REDUCER_NAME,
  PAYMENT_METHODS_LIST_REDUCER_NAME,
  PM_DEFAULT_REQUEST_REDUCER_NAME,
  SELECTED_PAYMENT_METHOD_REDUCER_NAME,
} from './consts'
import {
  defaultPaymentMethodsReducer,
  detachPaymentMethodsReducer,
  paymentMethodsListReducer,
  selectedPaymentMethodReducer,
} from './slice'

export const paymentMethodsReducer = combineReducers({
  [PAYMENT_METHODS_LIST_REDUCER_NAME]: paymentMethodsListReducer,
  [SELECTED_PAYMENT_METHOD_REDUCER_NAME]: selectedPaymentMethodReducer,
  [DETACH_PAYMENT_METHODS_REDUCER_NAME]: detachPaymentMethodsReducer,
  [PM_DEFAULT_REQUEST_REDUCER_NAME]: defaultPaymentMethodsReducer,
})
